import { useQuery } from '@tanstack/react-query'
import { useAuthStore } from '@/store/auth-store'
import { exportsService } from '@/features/file-exports/services/exports.service'
import { exportsKeys } from '@/features/file-exports/keys/exports.keys'

interface UseExportsOptions {
  refetchOnMount?: boolean | 'always'
}

export function useExports(page: number, options: UseExportsOptions = {}) {
  const accessToken = useAuthStore((s) => s.accessToken)

  return useQuery({
    queryKey: exportsKeys.list(page),
    queryFn: () => exportsService.list(page, accessToken!),
    enabled: !!accessToken,
    refetchOnMount: options.refetchOnMount,
  })
}
